import type { SubmitQuestionnaireApiResponse } from '../../assessment-portal/types/questionnaire';
import { clearBookingConfirmationSnapshot } from './booking-confirmation-snapshot';
import { clearQuestionnaireDraft } from './questionnaire-draft';
import type { IdentityConfirmValues, QuestionnaireCompletionDisplay } from '../types/flow';

/** Maps submit API workflow result to completion page display fields. */
export const buildQuestionnaireCompletionDisplay = (
  identity: IdentityConfirmValues,
  response: SubmitQuestionnaireApiResponse,
): QuestionnaireCompletionDisplay => {
  const workflow = response._embedded; // eslint-disable-line no-underscore-dangle

  return {
    firstName: identity.firstName.trim(),
    clinicianName: workflow?.specialist?.clinicianName ?? '',
    clinicianTitle: workflow?.specialist?.clinicianTitle ?? '',
    startDateTime: workflow?.appointment?.startDateTime ?? '',
  };
};

/** Clears browser storage used by the questionnaire flow after successful submit. */
export const clearQuestionnaireFlowStorage = (templateId: string): void => {
  clearQuestionnaireDraft(templateId);
  clearBookingConfirmationSnapshot();
};
